<template>
    <div class="dropdown">
        <div class="dropdown__trigger" 
            @click.stop="toggle"
            ref="trigger">
            <slot  name="trigger"></slot>
        </div>
        <div :class="'dropdown__container ' + positioningClasses" v-if="isDropdownVisible">
            <div class="dropdown__overlay" @click="toggle"></div>
            <div class="dropdown__content" @click.stop="() => {}">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
const VERTICAL_POSITIONS = {
    top: 'top',
    bottom: 'bottom',
    auto: 'auto'
};

const HORIZONTAL_POSITIONS = {
    left: 'left',
    right: 'right',
    auto: 'auto'
}

export default {
    name: 'BaseDropdown',
    emits: ['dropdownOpened', 'dropdownClosed'],
    props: {
        isOpened: Boolean,
        verticalPosition: {
            type: String,
            validator: function (value) {
                return Object.values(VERTICAL_POSITIONS).includes(value);
            }
        },
        horizontalPosition: {
            type: String,
            validator: function (value) {
                return Object.values(HORIZONTAL_POSITIONS).includes(value);
            }
        }
    },
    data() {
        return {
            isDropdownVisible: false,
            horizontal: HORIZONTAL_POSITIONS.left,
            vertical: VERTICAL_POSITIONS.bottom
        }
    },
    watch: {
        isOpened(value) {
            this.isDropdownVisible = value;
        }
    },
    computed: {
        positioningClasses() {
            const baseClass = 'dropdown__container_'
            const horizontalClass = baseClass + this.horizontal;
            const verticalClass = baseClass + this.vertical;

            return `${horizontalClass} ${verticalClass}`
        }
    },
    created() {
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
    },
    methods: {
        toggle() {
            this.isDropdownVisible = !this.isDropdownVisible;
            if (this.isDropdownVisible) {
                this.setPosition();
                this.$emit('dropdownOpened')
            } else {
                this.$emit('dropdownClosed')
            }
        },
        close() {
            this.isDropdownVisible = false;
            this.$emit('dropdownClosed');
        },
        open() {
            this.isDropdownVisible = true;
            this.$emit('dropdownOpened');
        },
        setPosition() {
            this.horizontal = this.getHorizontalPosition();
            this.vertical = this.getVerticalPosition();
        },
        getHorizontalPosition() {
            if (!this.horizontalPosition) {
                return HORIZONTAL_POSITIONS.left;
            }

            if (this.horizontalPosition !== HORIZONTAL_POSITIONS.auto) {
                return this.horizontalPosition;
            }

            const { x } = this.$refs.trigger.getBoundingClientRect();
            const screenWidth = window.innerWidth;
            const screenMiddle = screenWidth / 2;

            return x > screenMiddle ? HORIZONTAL_POSITIONS.left : HORIZONTAL_POSITIONS.right;
        },
        getVerticalPosition() {
            if (!this.verticalPosition) {
                return VERTICAL_POSITIONS.bottom;
            }

            if (this.verticalPosition !== VERTICAL_POSITIONS.auto) {
                return this.verticalPosition;
            }

            const { y } = this.$refs.trigger.getBoundingClientRect();
            const screenHeight = window.innerHeight;
            const screenMiddle = screenHeight / 2;

            return y > screenMiddle ? VERTICAL_POSITIONS.top : VERTICAL_POSITIONS.bottom;
        }
    }
}
</script>

<style lang="scss">
    .dropdown {
        position: relative;
        display: inline-block;

        &__container {
            position: absolute;
            z-index: 101;

            &_top {
                top: auto;
                bottom: calc(100% - 8px);
            }

            &_bottom {
                bottom: auto;
                top: calc(100% + 8px);
            }

            &_left {
                left: auto;
                right: 0;
            }

            &_right {
                right: auto;
                left: 0;
            }
        }

        &__overlay {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 100;
        }

        &__content,
        &__trigger {
            position: relative;
        }

        &__trigger {
            z-index: 4;
        }
    
        &__content {
            z-index: 101;
        }
    }
</style>